/**
 * Reduce the precision of a number to the given number of significant numbers.
 * This is useful to avoid having a max value of 4672.23 returned by the functions getMin/MaxValue.
 */
export const toPrecision = (number: number, precision: number) =>
    parseFloat(parseFloat(number.toString()).toPrecision(precision));

export const SMALL_AXIS_LABEL_FONT_SIZE = 8;
export const MEDIUM_AXIS_LABEL_FONT_SIZE = 10;
export const LARGE_AXIS_LABEL_FONT_SIZE = 12;

export const POLAR_OFFSET = 50; // diameter of the polar chart inner circle (in px)
